import { render, staticRenderFns } from "./WorksPage.vue?vue&type=template&id=bbf6286e&scoped=true&"
import script from "./WorksPage.vue?vue&type=script&lang=js&"
export * from "./WorksPage.vue?vue&type=script&lang=js&"
import style0 from "./WorksPage.vue?vue&type=style&index=0&id=bbf6286e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf6286e",
  null
  
)

export default component.exports